import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, MessageCircle, CreditCard, PartyPopper } from 'lucide-react';
import FadeInSection from '../components/FadeInSection';
import PageBanner from '../components/PageBanner';
import { useCms } from '../context/CmsContext';

const HoeWerktHet = () => {
  const { t, img } = useCms();
  const steps = [
    { icon: <MessageCircle size={48} />, title: t('hwh.step1_title', '1. Neem Contact Op'), description: t('hwh.step1_text', '') },
    { icon: <Calendar size={48} />, title: t('hwh.step2_title', '2. Offerte & Planning'), description: t('hwh.step2_text', '') },
    { icon: <CreditCard size={48} />, title: t('hwh.step3_title', '3. Bevestiging & Betaling'), description: t('hwh.step3_text', '') },
    { icon: <PartyPopper size={48} />, title: t('hwh.step4_title', '4. Geniet van het Feest!'), description: t('hwh.step4_text', '') },
  ];

  return (
    <div>
      <PageBanner
        image={img('banner.hwh')}
        title={t('hwh.hero_title', 'Hoe werkt het?')}
        subtitle={t('hwh.hero_subtitle', 'In 4 eenvoudige stappen naar de perfecte cocktailervaring op jullie locatie')}
      />

      {/* Steps */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {steps.map((step, index) => (
            <FadeInSection key={index} delay={index * 100}>
              <div className="bg-white p-8 rounded-lg shadow-elegant hover:shadow-xl transition-all duration-300">
                <div className="text-[#13498f] mb-4">
                  {step.icon}
                </div>
                <h3 className="text-2xl font-semibold mb-4 text-[#13498f]">{step.title}</h3>
                <p className="text-gray-700 leading-relaxed">{step.description}</p>
              </div>
            </FadeInSection>
          ))}
        </div>
      </section>

      {/* What We Provide */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-semibold text-center mb-12 text-[#13498f]">
            Wat leveren wij?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              'Professionele bartenders',
              'Mobiele cocktailbar',
              'Alle benodigde ingrediënten',
              'Glaswerk en servies',
              'IJs en garnishes',
              'Decoratie en styling',
              'Setup en afbouw',
              'Alcoholvrije opties',
              'Flexibele cocktailkeuze'
            ].map((item, idx) => (
              <div key={idx} className="bg-white p-4 rounded-lg shadow-sm flex items-center gap-3">
                <div className="w-2 h-2 bg-[#13498f] rounded-full"></div>
                <span className="text-gray-700">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Info */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <FadeInSection>
          <h2 className="font-serif-display text-5xl mb-6 text-[#13498f]">
            {t('hwh.pricing_title', 'Transparante Prijzen')}
          </h2>
        <div className="bg-white p-8 rounded-lg shadow-elegant mb-8">
          <div className="font-serif-display text-7xl text-[#13498f] mb-4">€6</div>
          <p className="text-xl text-gray-700 mb-4">per cocktail</p>
          <p className="text-gray-600 leading-relaxed font-light">
            {t('hwh.pricing_text', '')}
          </p>
        </div>
        <p className="text-gray-600 mb-8">
          Extra kosten kunnen zijn: reiskosten bij grote afstanden, 
          speciale wensen of verhuur van extra materiaal.
        </p>
        <Link to="/offerte" className="btn-primary text-lg">
          Vraag Direct een Offerte Aan
        </Link>
        </FadeInSection>
      </section>

      {/* FAQ Teaser */}
      <section className="bg-[#13498f] text-white py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <FadeInSection>
          <h2 className="text-4xl font-semibold mb-6">
            Nog vragen?
          </h2>
          <p className="text-xl mb-8 font-light">
            Bekijk onze veelgestelde vragen of neem direct contact met ons op
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/faq" className="btn-secondary text-lg">
              Bekijk FAQ
            </Link>
            <Link to="/contact" className="bg-white text-[#13498f] px-8 py-3 rounded-lg font-normal hover:bg-gray-100 transition-all duration-300">
              Contact Opnemen
            </Link>
          </div>
          </FadeInSection>
        </div>
      </section>
    </div>
  );
};

export default HoeWerktHet;
